import React from 'react';
import CourseCard from './CourseCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper/modules';

const CourseSlider = ({ courses }) => {
    return (
        <div>
            {courses?.length ? (
                <Swiper
                    slidesPerView={3}
                    spaceBetween={30}
                    freeMode={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                    className="mySwiper"
                    breakpoints={
                        {
                            1270: {
                                slidesPerView: 3
                            },
                            880: {
                                slidesPerView: 2
                            },
                            0: {
                                slidesPerView: 1
                            }
                        }
                    }
                >
                    {courses.map((course) => (
                        <SwiperSlide key={course?._id}>
                            <div className=''>
                                <CourseCard course={course} cardHeight='20rem' />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <p>No Course Found</p>
            )}
        </div>
    );
};

export default CourseSlider;